import { Application } from '@/types/application';
import { Detail, emptyValue } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { ValidationError, ValidationObject } from '@/types/validation';
import { isEmptyValue, isNullOrUndefined, isNumber, isObject, isString } from '@/util/typeGuards';

export const textblockUtil = (): ValidationObject<string | number | emptyValue | undefined> => {
  const validateTextblock = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ) => {
    const errors: ValidationError[] = [];
    const value = getValue(configuration, details);
    if (configuration.required && value === undefined) {
      errors.push({
        severity: 'error',
        message: `Block ${blockName} is missing a required value: ${configuration.label}`,
        id: nodeId
      });
    }
    return errors;
  };

  const getValue = (configuration: Configuration, initVal: unknown): string | number | emptyValue | undefined => {
    if (isNullOrUndefined(initVal)) return;
    if (isString(initVal) || isNumber(initVal) || isEmptyValue(initVal)) {
      return initVal;
    }
    if (isObject(initVal)) {
      const prop = initVal[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate: validateTextblock,
    getValue: getValue
  };
};
